import type {ReportingChartHtmlParams} from './ConnectElementDefinitions/reporting-chart';

export const RECENT_PAYMENTS_HTML_ATTRIBUTE = 'recent-payments' as const;
export const RECENT_PAYOUTS_HTML_ATTRIBUTE = 'recent-payouts' as const;
export const RECENT_TRANSACTIONS_HTML_ATTRIBUTE =
  'recent-transactions' as const;
export const IS_HOSTED_DASHBOARD_ATTRIBUTE = 'is-hosted-dashboard' as const;

/**
 * This list contains the entirety of the HTML attributes specified by connect embedded components.
 * Adding an attribute to a component that a platform can use requires API review.
 */

export type ConnectHtmlAttributeType =
  /** GA API reviewed  */
  // Connect onboarding
  | 'full-terms-of-service-url'
  | 'recipient-terms-of-service-url'
  | 'privacy-policy-url'
  | 'skip-terms-of-service-collection'

  // Payment details
  | 'payment'

  // Issuing
  | 'default-card'
  | 'card-switching'
  | 'show-spend-controls'
  | 'issuing-program'

  /** Preview API reviewed  */

  // Reporting
  | keyof ReportingChartHtmlParams

  // Issuing
  | 'cardholder'
  | 'transaction'

  // Capital
  | 'default-financing-offer'
  | 'show-financing-selector'
  | 'faq-url'
  | 'support-url'
  | 'layout'
  | 'eligibility-criteria-url'
  | 'how-capital-works-url'
  | 'enum-disable-view-offer-button'
  | 'resume-initiated-application'
  | 'disable-nested-capital-financing-application'
  | 'presentation-mode'

  // Payment method settings
  | 'payment-method-configuration'

  /** Internal / not API reviewed  */

  // Stripe apps
  | 'app'
  | 'test'
  | 'user-id'

  // Connect onboarding
  | 'align'
  | 'collect'
  | 'intent'
  | 'analytics-flow'
  | 'analytics-prefix'
  | 'show-icons'
  | 'emit-v2-account-link-webhook'
  | 'show-verbose-redirect'
  | 'show-save-for-later'
  | 'hide-footer-links'
  | 'enable-address-autocomplete'
  | 'preselected-legal-entity-token'
  | 'debug'
  | 'use-platform-branding-settings'
  | 'edit-payout-schedule-enabled'
  | 'kyc-recipient-account-id'

  // Account management
  | 'show-express-settings'

  // Issuing
  | 'issuing-element-config'

  // Treasury
  | 'financial-account'
  | 'currency'

  // Recipients
  | 'data-source'

  // Payments
  | typeof RECENT_PAYMENTS_HTML_ATTRIBUTE

  // Payouts
  | 'instant-payouts'
  | typeof RECENT_PAYOUTS_HTML_ATTRIBUTE
  | 'payout'
  | 'show-manual-payout-schedule-contact-platform-message'
  | 'hide-manual-payout-schedule-status'

  // Payouts entry point
  | 'payout-purpose'
  | 'selected-currency'

  // Global payouts
  | 'gp-recipient-account-id'
  | 'payout-link-id'

  // Payment details
  | 'charge-id'
  | 'visible'
  | 'inline'

  // Debug utils
  | 'debug-utils-test-attribute'

  // Debug UI config
  | 'simplified'
  | 'from-internal-site'
  | 'express-branding-settings'
  | 'docsite-user-session-key'
  | 'docsite-account-id'
  | 'docsite-livemode'

  // Earnings chart
  | 'chart-aspect-ratio'

  // Transactions list
  | typeof RECENT_TRANSACTIONS_HTML_ATTRIBUTE

  // Debug hosted dashboard preview
  | 'icon'
  | 'display-name'

  // Notification banner and Terminal components
  | typeof IS_HOSTED_DASHBOARD_ATTRIBUTE

  // Capital
  | 'application-presentation'
  | 'capital-scheme'
  | 'platform-return-url'
  | 'direct-financing-object'

  // Outbound payment details
  | 'outbound-payment-id';
